export const STOCK_RECONCILE = "STOCK_RECONCILE";
export const STOCK_RECONCILE_SUCCESS = "STOCK_RECONCILE_SUCCESS";
export const STOCK_RECONCILE_FAILED = "STOCK_RECONCILE_FAILED";